import styled, { css } from 'styled-components'
import { spacing_0_25, spacing_1, spacing_1_5, spacing_2, spacing_3 } from 'components/corpSite/components/theme/spacing'
import { h2_bold, body } from 'components/corpSite/components/theme/type-styles'
import { xsMd } from 'components/corpSite/components/theme/utils/media-query'
import { white } from 'components/corpSite/components/theme/colors'
import { proxima_nova } from 'components/corpSite/components/theme/font'

export function makeImageTile (element) {
  return styled(element)`
    font-family: ${proxima_nova};
    margin-right: ${ spacing_1 };
    margin-bottom: ${ spacing_2 };
    padding: ${ spacing_1_5 } ${ spacing_3 };
    width: ${props => props.width || '336px'};
    height: ${props => props.height || '512px'};
    text-align: ${props => props.align || 'left'};
    color: ${ white };
    display: flex;
    flex-direction: row;
    text-align: center;
    align-items: flex-end;
    p {
      ${body};
      margin-bottom: 0;
    }
    h2 {
      ${h2_bold};
      color: ${white};
      margin-bottom: ${spacing_0_25};
    }

    background-image: ${props => css`url(${props.imagePath})`};
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;

    &:hover {
      cursor: pointer;
      text-decoration: none;
      color: ${white};
    }

    ${xsMd(css`
      margin-right: 0;
      width: 100%;
      max-width: 353px;

      &:last-child {
        margin-bottom: 0;
      }

      ${props => props.mobileRow && css`
        max-width: 100%;
        height: ${props => props.mobileHeight || '320px'};
      `}
    `)}
  `
}

export default makeImageTile
